<script setup lang="ts">
const props = defineProps({
  files: null
})

const firstWidthPx = computed(() => first(props.files)?.mediaWidthPx())
const firstHeightPx = computed(() => first(props.files)?.mediaHeightPx())
const firstWidthCm = computed(() => first(props.files)?.mediaWidthCm())
const firstHeightCm = computed(() => first(props.files)?.mediaHeightCm())
const sameWidthPx = computed(() => all(Object.values(props.files), f => f.mediaWidthPx() === firstWidthPx.value))
const sameHeightPx = computed(() => all(Object.values(props.files), f => f.mediaHeightPx() === firstHeightPx.value))
const sameWidthCm = computed(() => all(Object.values(props.files), f => f.mediaWidthCm() === firstWidthPx.value))
const sameHeightCm = computed(() => all(Object.values(props.files), f => f.mediaHeightCm() === firstHeightPx.value))
</script>

<template>
  <div class="view inline">
    <div class="label">
      Dimensions
    </div>
    <div class="dimensions">
      <div v-if="sameWidthPx">
        {{ firstWidthPx }}px
      </div>
      <div v-else-if="sameWidthCm">
        {{ firstWidthCm }} cm
      </div>
      <panel-details-property-placeholder v-else />
      <div class="x-mark">
        ×
      </div>
      <div v-if="sameHeightPx">
        {{ firstHeightPx }}px
      </div>
      <div v-else-if="sameHeightCm">
        {{ firstHeightCm }} cm
      </div>
      <panel-details-property-placeholder v-else />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.dimensions
  @apply inline-flex gap-1
.x-mark
  @apply text-[#{$global-t-tertiary}]

.label
  @apply flex-none font-normal text-[#{$global-t-tertiary}] t-menu-sm

.view
  @apply flex flex-col gap-[#{$panel-properties-gap-properties}]
.view.inline
  @apply flex-row justify-between items-center

.value
  @apply text-ellipses-inline t-panel-sm text-right
  &.multiline
    @apply whitespace-normal overflow-auto max-h-40 break-words
  &:not(.multiline)
    @apply text-ellipses-inline
  &.monospace
    @apply
</style>
